import { BadgeWithIconProps } from "../../data-model/badgeWithIconProps";

const BadgeWithIcon = ({
  text,
  icon,
  onClick,
  textColor,
  bgColor,
  id,
  style,
  borderColor,
}: BadgeWithIconProps) => {
  return (
    <div
      className="badge-drop-downn badge-container flex w-max items-center gap-1 rounded-[0.25rem] px-2 py-1 hover:cursor-pointer"
      id={id}
      onClick={(e) => {
        onClick?.(id);
      }}
      style={{
        backgroundColor: bgColor,
        ...(borderColor && {
          borderColor: borderColor,
          borderWidth: "0.25px",
          borderStyle: "solid",
        }),
        ...style,
      }}
    >
      <div
        className="badge-drop-down text text-x-tiny font-semibold leading-5"
        style={{ color: textColor }}
      >
        {text}
      </div>
      {icon && <div className="badge-drop-down icon">{icon}</div>}
    </div>
  );
};

export default BadgeWithIcon;
